import { CgFormatCenter } from 'react-icons/cg';
import { RiAdminFill } from 'react-icons/ri';
import { ACCESS_LEVEL } from './constant/constant.js';
import { HiSquares2X2 } from "react-icons/hi2";
import { TbSettingsFilled } from "react-icons/tb";
import { BsFillTrophyFill } from "react-icons/bs";
import { FaPeopleArrows } from "react-icons/fa6";
import { HiSwitchHorizontal } from "react-icons/hi";
import { FaMoneyBillTransfer } from "react-icons/fa6";
import { PiUsersFourFill } from "react-icons/pi";
import { FaImages } from "react-icons/fa";
import { FaRankingStar } from "react-icons/fa6";
import { CgWebsite } from "react-icons/cg";
import { LuCreativeCommons } from "react-icons/lu";
import { RiSecurePaymentLine } from "react-icons/ri";
import { BsBank2 } from "react-icons/bs";
import { BiSolidOffer } from "react-icons/bi";
import { AiFillBank } from "react-icons/ai";
import { PiBookmarkSimpleFill } from "react-icons/pi";
import { MdPolicy } from "react-icons/md";
import { RiDashboard3Fill } from "react-icons/ri";
import { GiMoneyStack } from "react-icons/gi";
import { MdAccountBalanceWallet } from "react-icons/md";
import { HiMiniUserMinus } from "react-icons/hi2";
import { TbAffiliateFilled } from "react-icons/tb";
import { SiYoutubestudio } from "react-icons/si";
import { TbTournament } from "react-icons/tb";
import { LiaAdversal } from "react-icons/lia";

import { VscFeedback } from "react-icons/vsc";


const style={
    verticalAlign: "middle", marginRight: "4px", flexShrink: 0
}


 const NavItem = [
    {
        title: 'Dashboard',
        path:'/dashboard',
        icon: <HiSquares2X2 style={style}/>,
        access_level: ACCESS_LEVEL.ADMIN
    },
    {
        title: 'Shift Management',
        path:'/shift-management',
        icon: <RiAdminFill style={style}/>,
        access_level: ACCESS_LEVEL.CASHIER
    },
    {
        title: 'Deposit',
        path:'/deposit',
        icon: <RiAdminFill style={style}/>,
        access_level: ACCESS_LEVEL.SUB_ADMIN
    },
    {
        title: 'Chip Issue',
        path:'/chip-issue',
        icon: <RiAdminFill style={style}/>,
        access_level: ACCESS_LEVEL.SUB_ADMIN
    },
    {
        title: 'Chip Cash-Out',
        path:'/chip-cashout',
        icon: <RiAdminFill style={style}/>,
        access_level: ACCESS_LEVEL.SUB_ADMIN
    },
    {
        title: 'Float Exchange',
        path:'/float-exchange',
        icon: <RiAdminFill style={style}/>,
        access_level: ACCESS_LEVEL.SUB_ADMIN
    },
    {
        title: 'Withdrawal',
        path:'/withdrawal',
        icon: <RiAdminFill style={style}/>,
        access_level: ACCESS_LEVEL.SUB_ADMIN
    },
    // Chip Exchange through Account Manager below are access_level ADMIN on
    // purpose, not because only main admins may use them: checkNav's
    // `data.access_level <= user.accessLevel` shortcut auto-grants ANY item at
    // or below a sub-admin's own tier, permissions array or not -- these used
    // to sit at SUB_ADMIN, so an 80-level admin saw every one of them
    // regardless of what was actually ticked in their Access Module list.
    // Tagging them ADMIN forces sub-100 accounts through the accessModule
    // (permissions) check below instead, so an admin scoped to e.g. just "Tip
    // Manager" only sees "Tip Manager". (Deposit/Chip Issue/Chip Cash-Out/
    // Withdrawal/Transaction stay SUB_ADMIN -- they're baseline cashier tasks,
    // not individually permission-gated here.)
    {
        title: 'Chip Exchange',
        path:'/chip-exchange',
        icon: <HiSwitchHorizontal style={style}/>,
        access_level: ACCESS_LEVEL.ADMIN
    },
    {
        title: 'Shift Ledger',
        path:'/shift-ledger',
        icon: <RiAdminFill style={style}/>,
        access_level: ACCESS_LEVEL.ADMIN
    },
    {
        title: 'Session Manager',
        path:'/session-manager',
        icon: <RiAdminFill style={style}/>,
        access_level: ACCESS_LEVEL.ADMIN
    },
    {
        title: 'Transaction',
        path:'/transaction',
        icon: <RiAdminFill style={style}/>,
        access_level: ACCESS_LEVEL.SUB_ADMIN
    },
    {
        title: 'Rake Manager',
        path:'/rake',
        icon: <RiAdminFill style={style}/>,
        access_level: ACCESS_LEVEL.ADMIN
    },
    {
        title: 'Tip Manager',
        path:'/tip-manager',
        icon: <RiAdminFill style={style}/>,
        access_level: ACCESS_LEVEL.ADMIN
    },
    {
        title: 'Expense Manager',
        path:'/expense',
        icon: <RiAdminFill style={style}/>,
        access_level: ACCESS_LEVEL.ADMIN
    },
    {
        title: 'Petty Expense',
        path:'/daily-expense',
        icon: <RiAdminFill style={style}/>,
        access_level: ACCESS_LEVEL.ADMIN
    },
    {
        title: 'Credit Manager',
        path:'/loan',
        icon: <RiAdminFill style={style}/>,
        access_level: ACCESS_LEVEL.ADMIN
    },
    {
        title: 'Chips Master',
        path:'/chips-master',
        icon: <GiMoneyStack style={style}/>,
        access_level: ACCESS_LEVEL.ADMIN
    },
    {
        title: 'Wallet Manager',
        path:'/wallet-manager',
        icon: <MdAccountBalanceWallet style={style}/>,
        access_level: ACCESS_LEVEL.ADMIN
    },
    {
        title: 'User Manager',
        path:'/user-manager',
        icon: <RiAdminFill style={style}/>,
        access_level: ACCESS_LEVEL.ADMIN
    },
    {
        title: 'Telegram Cashier',
        path:'/telegram-cashier',
        icon: <RiAdminFill style={style}/>,
        access_level: ACCESS_LEVEL.ADMIN
    },
    {
        title: 'Employee Manager',
        path:'/employee-manager',
        icon: <RiAdminFill style={style}/>,
        access_level: ACCESS_LEVEL.ADMIN
    },
    {
        title: 'Bad Beat Jackpot',
        path:'/bad-beat-jackpot',
        icon: <GiMoneyStack style={style}/>,
        access_level: ACCESS_LEVEL.ADMIN
    },
    {
        title: 'Dealer Hands',
        path:'/hand-entries',
        icon: <GiMoneyStack style={style}/>,
        access_level: ACCESS_LEVEL.ADMIN
    },
    {
        title: 'Account Manager',
        path:'/account-manager',
        icon: <MdAccountBalanceWallet style={style}/>,
        access_level: ACCESS_LEVEL.ADMIN
    },
    {
        title: 'Player Manager',
        path:'/player-manager',
        icon: <PiUsersFourFill style={style}/>,
        access_level: ACCESS_LEVEL.ADMIN
    },
    {
        title: 'Settings',
        path:'/settings',
        icon: <TbSettingsFilled style={style}/>,
        access_level: ACCESS_LEVEL.ADMIN
    },


]


export default NavItem
